// components/paie/NoticePaiementCourte.jsx
// ============================================================================
// RAPPEL AVANT PAIEMENT — VERSION COURTE
// ============================================================================
// Affiché en tête des tableaux Enseignants, Personnel administratif et
// Employés hybrides. La version complète est sur la page « Paiement des
// salaires » (SalaryManagementPage). Purement informatif : les contrôles sont
// faits par le serveur.
// ============================================================================

import React from 'react';
import { Info } from 'lucide-react';

const NoticePaiementCourte = () => (
  <div className="mb-5 flex items-start gap-3 rounded-lg border border-[#246990]/20 bg-[#eef7fb] px-4 py-3 text-sm text-slate-700">
    <Info className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#246990]" />
    <p className="leading-relaxed">
      Seuls les employés ayant un pointage du mois <strong>envoyé en comptabilité</strong> apparaissent ici. Le
      paiement n'est possible qu'après l'<strong>État des salaires</strong> : dotation acceptée par la caisse centrale
      et état validé.
    </p>
  </div>
);

export default NoticePaiementCourte;
